// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.route-enter-from {\n  opacity: 0;\n  transform: translateX(100px);\n}\n.route-enter-active {\n  transition: all 0.3s ease-out;\n}\n.route-leave-to {\n  opacity: 0;\n  transform: translateX(-100px);\n}\n.route-leave-active {\n  transition: all 0.3s ease-in;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
